import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
import { staggerContainer, staggerItem } from './AnimatedSection';
import { quickServices } from './homeData';
interface PopularServicesProps {
  onNavigate: (page: string) => void;
}
export function PopularServices({
  onNavigate
}: PopularServicesProps) {
  return <section className="py-10 sm:py-24 relative overflow-hidden bg-gradient-to-b from-slate-50 via-indigo-50/30 to-slate-50" data-id="element-15906">
      <div className="absolute inset-0 pointer-events-none" data-id="element-15907">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full border border-indigo-200/20 animate-spin-slow" data-id="element-15908" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full border border-violet-200/15" style={{
        animation: 'spin-slow 30s linear infinite reverse'
      }} data-id="element-15909" />
        <div className="absolute top-20 right-[15%] w-48 h-48 bg-indigo-300/10 rounded-full blur-3xl" data-id="element-15910" />
        <div className="absolute bottom-20 left-[10%] w-64 h-64 bg-violet-300/10 rounded-full blur-3xl" data-id="element-15911" />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-15912">
        <motion.div className="text-center mb-6 sm:mb-14" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-15913">
          <div className="inline-flex items-center px-3 sm:px-4 py-1 sm:py-1.5 rounded-full bg-indigo-100/60 text-indigo-600 text-[10px] sm:text-xs font-semibold uppercase tracking-[0.15em] mb-3 sm:mb-4 backdrop-blur-sm border border-indigo-200/40" data-id="element-15914">
            <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1.5 sm:mr-2" data-id="element-15915" />
            Наши услуги
          </div>
          <h2 className="text-xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-2 sm:mb-3" data-id="element-15916">
            Популярные услуги
          </h2>
          <p className="text-xs sm:text-lg text-slate-500 max-w-xl mx-auto" data-id="element-15917">
            Выберите формат, который подходит именно вам
          </p>
        </motion.div>

        {/* Mobile: compact list */}
        <div className="sm:hidden space-y-2.5" data-id="element-15918">
          {quickServices.map(service => <div key={service.id} className="flex items-center gap-3 bg-white/80 backdrop-blur-sm rounded-xl border border-slate-200/60 p-3 cursor-pointer active:bg-slate-50" onClick={() => onNavigate(`service-${service.id}`)} data-id="element-15919">
              <div className={`w-10 h-10 rounded-xl ${service.accent} flex items-center justify-center flex-shrink-0`} data-id="element-15920">
                {service.icon}
              </div>
              <div className="flex-grow min-w-0" data-id="element-15921">
                <h3 className="text-sm font-bold text-slate-900" data-id="element-15922">
                  {service.title}
                </h3>
                <p className="text-[10px] text-slate-500 truncate" data-id="element-15923">
                  {service.desc}
                </p>
              </div>
              <span className="text-xs font-bold text-slate-700 whitespace-nowrap" data-id="element-15924">
                {service.price}
              </span>
            </div>)}
        </div>

        {/* Desktop: card grid */}
        <motion.div className="hidden sm:grid sm:grid-cols-2 lg:grid-cols-3 gap-6" variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} data-id="element-15925">
          {quickServices.map((service, idx) => {
          const glowColors = ['hover:shadow-indigo-200/50 border-t-indigo-400', 'hover:shadow-amber-200/50 border-t-amber-400', 'hover:shadow-slate-300/50 border-t-slate-400', 'hover:shadow-rose-200/50 border-t-rose-400', 'hover:shadow-emerald-200/50 border-t-emerald-400', 'hover:shadow-violet-200/50 border-t-violet-400'];
          const iconGlow = ['shadow-indigo-300/40 ring-indigo-100', 'shadow-amber-300/40 ring-amber-100', 'shadow-slate-300/40 ring-slate-100', 'shadow-rose-300/40 ring-rose-100', 'shadow-emerald-300/40 ring-emerald-100', 'shadow-violet-300/40 ring-violet-100'];
          const zodiacSymbols = ['♈', '☉', '☊', '♎', '♃', '☿'];
          return <motion.div key={service.id} variants={staggerItem} data-id="element-15926">
                <motion.div className={`relative bg-white/80 backdrop-blur-sm rounded-2xl border border-slate-200/60 border-t-2 ${glowColors[idx]} p-6 flex flex-col h-full cursor-pointer shadow-sm hover:shadow-xl transition-all duration-500 group`} whileHover={{
              y: -6,
              transition: {
                duration: 0.3,
                ease: 'easeOut'
              }
            }} onClick={() => onNavigate(`service-${service.id}`)} data-id="element-15927">
                  <span className="absolute top-4 right-5 text-4xl font-light text-slate-100 select-none group-hover:text-slate-200/80 transition-colors duration-500" data-id="element-15928">
                    {zodiacSymbols[idx]}
                  </span>
                  <div className="relative mb-6" data-id="element-15929">
                    <div className={`w-14 h-14 rounded-2xl ${service.accent} flex items-center justify-center shadow-lg ${iconGlow[idx]} ring-4 transition-shadow duration-500 group-hover:shadow-xl`} data-id="element-15930">
                      {service.icon}
                    </div>
                  </div>
                  <h3 className="text-lg font-bold text-slate-900 mb-2 group-hover:text-indigo-700 transition-colors" data-id="element-15931">
                    {service.title}
                  </h3>
                  <p className="text-sm text-slate-500 mb-6 flex-grow leading-relaxed" data-id="element-15932">
                    {service.desc}
                  </p>
                  <div className="flex items-center justify-between pt-5 border-t border-slate-100/80 mt-auto" data-id="element-15933">
                    <span className="text-lg font-bold bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent" data-id="element-15934">
                      {service.price}
                    </span>
                    <span className="text-sm font-medium text-indigo-500 group-hover:text-indigo-600 flex items-center transition-colors" data-id="element-15935">
                      Подробнее <ArrowRight className="w-4 h-4 ml-1" data-id="element-15936" />
                    </span>
                  </div>
                </motion.div>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}